export const toFilterArray = value =>
  Array.isArray(value)
    ? value
    : value === undefined || value === null || value === ''
    ? []
    : [value];

export const sameFilterValue = (a, b) => {
  if (Array.isArray(a) || Array.isArray(b)) {
    const x = Array.isArray(a) ? a : [];
    const y = Array.isArray(b) ? b : [];
    return x.length === y.length && x.every((value, i) => value === y[i]);
  }
  return a === b;
};
